// extracted by mini-css-extract-plugin
export default {"iconLabel":"Icon_iconLabel__KEfUb","lg":"Icon_lg__c4Lzd"};